import {stepJump} from "../stepForm"

$('#editPayment').click(function() {
    stepJump($(this).parents('.form-progress'), 1);
});

$('#editBilling, #editShipping').click(function() {
    stepJump($(this).parents('.form-progress'), 0);
});
